<section class="search-area">
  <div class="container">
    <div class="search-area-child">
      <app-search-filter
        (submitEmit)="onSubmitEmitCatch($event)"></app-search-filter>
    </div>
  </div>
</section>
